export default __webpack_public_path__ + "static/media/avatar.981b4f16.png";